import React, { useEffect, useRef } from 'react';
interface TradingViewWidgetProps {
  /** Embed script URL from TradingView. */
  scriptSrc: string;
  /** JSON configuration passed to the embed script. */
  config: Record<string, unknown>;
  /** Optional attribution link shown under the widget. */
  copyright?: {
    href: string;
    label: string;
  };
}

/**
 * Generic loader for TradingView embed widgets. The embed script reads its
 * config from its own inner text, so it must be injected per instance.
 */
export function TradingViewWidget({
  scriptSrc,
  config,
  copyright
}: TradingViewWidgetProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const widget = document.createElement('div');
    widget.className = 'tradingview-widget-container__widget';
    widget.style.height = '100%';
    widget.style.width = '100%';
    container.appendChild(widget);
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify(config);
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scriptSrc]);
  return <div className="flex h-full w-full flex-col" data-id="element-185" data-mp="tej9yxvux634">
      <div ref={containerRef} className="tradingview-widget-container min-h-0 flex-1" data-id="element-186" data-mp="tg2u4zkmw1a6" />
      {copyright ? <div className="shrink-0 px-3 pb-2 pt-1.5" data-id="element-187" data-mp="13bxjedjd4ulx">
          <a href={copyright.href} rel="noopener nofollow" target="_blank" className="font-mono text-[10px] text-white/30 transition-colors duration-150 ease-out hover:text-cyan-vip" data-id="element-188" data-mp="13amgsh1nlswe">
            {copyright.label} <span className="text-white/20" data-id="element-189" data-mp="395xi391kaxht">by TradingView</span>
          </a>
        </div> : null}
    </div>;
}